import request, { _POST } from "@/services/request";
import {
  DakeEditSpecialEventIdParamsReq,
  DakeEditSpecialEventSubmitReq,
  DakeGenShortLinkReq,
  DakeGenShortLinkRsp,
  DakeListSpecialEvent1Req,
  DakeListSpecialEventOptLogReq,
  DakeListSpecialEventOptLogResp,
  DakeListSpecialEventProductReq,
  DakeListSpecialEventProductResp,
  DakeListSpecialProductEventResp,
  DakeUpdateShowInHomeReq,
  DakeUploadHeadImgExportRsp,
  UpdateDakeEditSpecialEventSubmitReq,
} from "@/data-contracts";

/**
 * 列举商品列表
 * /admin/specialEvent/listProducts
 * @return DakeListSpecialEventProductResp
 * @param params
 * */
const listSpecialEventProduct = (params?: DakeListSpecialEventProductReq) => {
  return request<DakeListSpecialEventProductResp, DakeListSpecialEventProductReq>(
    _POST,
    "/admin/specialEvent/listProducts"
  )(params ?? {});
};

/**
 *
 * 列举活动列表
 *
 * /admin/specialEvent/list
 *
 * @return DakeListSpecialProductEventResp
 *
 * @param params
 * */

const listSpecialEvent = (params?: DakeListSpecialEvent1Req) => {
  return request<DakeListSpecialProductEventResp, DakeListSpecialEvent1Req>(
    _POST,
    "/admin/specialEvent/list"
  )(params ?? {});
};

/**
 *
 * 创建活动
 *
 * /admin/specialEvent/create
 *
 * @return null
 *
 * @param params DakeEditSpecialEventSubmitReq
 * */
const createSpecialEvent = (params: DakeEditSpecialEventSubmitReq) => {
  return request<null, DakeEditSpecialEventSubmitReq>(_POST, "/admin/specialEvent/create")(params);
};

/**
 * 更新活动
 * /admin/specialEvent/update
 *
 * @return null
 *
 * @param params UpdateDakeEditSpecialEventSubmitReq
 * */
const updateSpecialEvent = (params: UpdateDakeEditSpecialEventSubmitReq) => {
  return request<null, UpdateDakeEditSpecialEventSubmitReq>(
    _POST,
    "/admin/specialEvent/update"
  )(params);
};

/**
 * 删除活动
 * /admin/specialEvent/delete
 * @param params DakeEditSpecialEventIdParamsReq
 * @return null
 * */
const deleteSpecialEvent = (params: DakeEditSpecialEventIdParamsReq) => {
  return request<null, DakeEditSpecialEventIdParamsReq>(
    _POST,
    "/admin/specialEvent/delete"
  )(params);
};

/**
 * 更新活动是否在首页展示
 * /admin/specialEvent/updateShowInHome
 *
 * @param params DakeUpdateShowInHomeReq
 * @return null
 * */
const updateSpecialEventShowInHome = (params: DakeUpdateShowInHomeReq) => {
  return request<null, DakeUpdateShowInHomeReq>(
    _POST,
    "/admin/specialEvent/updateShowInHome"
  )(params);
};

/**
 *
 * 列举活动操作日志
 *
 * /admin/specialEvent/listOptLog
 * @param params DakeListSpecialEventOptLogReq
 *
 * @return DakeListSpecialEventOptLogResp
 * */
const listSpecialEventOptLog = (params?: DakeListSpecialEventOptLogReq) => {
  return request<DakeListSpecialEventOptLogResp, DakeListSpecialEventOptLogReq>(
    _POST,
    "/admin/specialEvent/listOptLog"
  )(params ?? {});
};

/**
 * 专场活动导出
 *
 * /admin/specialEvent/export
 *
 * @param params DakeListSpecialEvent1Req
 *
 * @return DakeUploadHeadImgExportRsp
 *
 * */
const exportSpecialEvent = (params?: DakeListSpecialEvent1Req) => {
  return request<DakeUploadHeadImgExportRsp, DakeListSpecialEvent1Req>(
    _POST,
    "/admin/specialEvent/export"
  )(params ?? {});
};

/**
 *
 * 获取短链
 *
 * /dake-biz/mp/gen_short_link
 *
 * @param params DakeGenShortLinkReq
 *
 * @return DakeGenShortLinkRsp
 *
 * */
const genShortLink = (params: DakeGenShortLinkReq) => {
  return request<DakeGenShortLinkRsp, DakeGenShortLinkReq>(
    _POST,
    "/dake-biz/mp/gen_short_link"
  )(params);
};

const specialEventConfigurationApis = {
  listSpecialEventProduct,
  listSpecialEvent,
  createSpecialEvent,
  updateSpecialEvent,
  deleteSpecialEvent,
  updateSpecialEventShowInHome,
  listSpecialEventOptLog,
  exportSpecialEvent,
  genShortLink,
};

export default specialEventConfigurationApis;
